import { useState, useEffect } from "react";

const useWindowBreakpoint = breakpoint => {
	const getMatches = () => window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
	const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(getMatches);

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
		const handleResize = () => {
			setIsBelowBreakpoint(mediaQuery.matches);
		};

		mediaQuery.addEventListener("change", handleResize);

		// Initial check
		handleResize();

		return () => mediaQuery.removeEventListener("change", handleResize);
	}, [breakpoint]);

	return isBelowBreakpoint;
};

export default useWindowBreakpoint;
